/**
 * CheckoutSuccessPage — Phase 3.
 * Stripe redirects here after successful checkout.
 * Shows confirmation, then auto-redirects to the Subscription tab.
 */

import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { HiOutlineCheckCircle } from 'react-icons/hi2'

export default function CheckoutSuccessPage() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const sessionId = params.get('session_id')

  useEffect(() => {
    // Stripe webhook handles the actual subscription activation server-side.
    // We just wait a moment then send the user to their subscription tab.
    const t = setTimeout(() => navigate('/profile-settings?tab=subscription'), 4000)
    return () => clearTimeout(t)
  }, [navigate])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cyan-50 to-blue-50 px-4">
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-8 text-center">
        <div className="inline-flex w-16 h-16 rounded-full bg-green-100 items-center justify-center mb-5">
          <HiOutlineCheckCircle className="w-9 h-9 text-success" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Subscription confirmed!</h1>
        <p className="text-gray-600 mb-6">
          Welcome to OVACS. Your subscription is now active and you can keep uploading without interruption.
        </p>
        <p className="text-sm text-gray-500">
          Taking you to your subscription details…
        </p>
        {sessionId && (
          <p className="text-xs text-gray-400 mt-4 font-mono">
            ref: {sessionId.slice(0, 16)}…
          </p>
        )}
      </div>
    </div>
  )
}
